import { render, staticRenderFns } from "./shareProduct.vue?vue&type=template&id=22baa5ff&scoped=true"
import script from "./shareProduct.vue?vue&type=script&lang=js"
export * from "./shareProduct.vue?vue&type=script&lang=js"
import style0 from "./shareProduct.vue?vue&type=style&index=0&id=22baa5ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22baa5ff",
  null
  
)

export default component.exports